// axios nao pega a autorizacao, nao dá para usar 
// estudar se for o caso
// CANCELADO da api nao pega o teste de response, voltei

import { toastr } from "react-redux-toastr"
import api from "../../../services/api"

import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import BaseurlApi from "../../../services/baseurlapi"

export function getData(codigoPuxada) {
    return (dispatch) => {
        axios.get(`${BaseurlApi}/GetCustomerGroupPricing?codigoPuxada=${codigoPuxada}`, {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_CustGprPcg",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro custGprPcgActions getData: " + error)
            })
    };
}

export function enviaCustGprPcgRegistros(arraycustGprPcg_groupId, arraycustGprPcg_customerId, codpuxada, usuario) {

    return (dispatch) => {
        api.post(`/Tb_Log_Envio_custGprPcg/IncluiLogCustGprPcg?CodPuxada=${codpuxada}&Usuario=${usuario}`, {
            "ArraygroupId": arraycustGprPcg_groupId
            , "ArraycustomerId": arraycustGprPcg_customerId
        }
        )
            .then(response => {
                dispatch([
                    getData(0)
                ])
                dispatch([
                    getData(codpuxada)
                ])
            })
            .catch(error => {
                toastr.error("Erro custGprPcgActions enviaRegistros: " + error.statusText)
            })
    }
}

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro priceActions getDataTdsRevendas: " + error)
            })
    };
}